import type {UserSettingsConfig} from "../userSettingsPage";
import {UserInformationPanel} from "./userInformationPanel";
import {EmailSettingsPanel} from "./emailSettingsPanel";
import {AppearancePanel} from "./appearancePanel";
import {ExternalAuthPanel} from "./externalAuthPanel";
import {TerminalPanel} from "./terminalPanel";
import {CalendarPanel} from "./calendarPanel";
import {CalendarSyncPanel} from "./calendarSyncPanel";
import {AbsenceCalendarLinks} from "@/features/absence/absenceCalendarLinks";
import type {AppearancePreference} from "@/shared/appearance";

export interface UserSettingsAppProps {
	config: UserSettingsConfig;
	appearancePreference: AppearancePreference | null;
}

export function UserSettingsApp({config, appearancePreference}: UserSettingsAppProps) {
	const hasConnectedMobileDevices = Boolean(config.connectedMobileDevices);

	return (
		<div className="row">
			<div className="col-lg-6">
				<UserInformationPanel
					clientIdentifier={config.clientIdentifier}
					accountOwner={config.accountOwner}
					showChangePasswordButton={config.showChangePasswordButton}
					hasConnectedMobileDevices={hasConnectedMobileDevices}
					passwordStrengthValidation={config.passwordStrengthValidation}
				/>
				<EmailSettingsPanel
					newsletter={config.newsletter}
					runningTimerWarningAfterHour={config.runningTimerWarningAfterHour}
					workingTimeRequestStatusEmail={config.workingTimeRequestStatusEmail}
					workingTimeRequestsEnabled={config.workingTimeRequestsEnabled}
				/>
				{appearancePreference !== null && <AppearancePanel preference={appearancePreference}/>}
				{(config.googleLoginAvailable || config.microsoftLoginAvailable) && (
					<ExternalAuthPanel
						googleLoginAvailable={config.googleLoginAvailable}
						microsoftLoginAvailable={config.microsoftLoginAvailable}
						externalAuthOnly={config.externalAuthOnly}
						connections={config.externalAuthConnections}
						hasConnectedMobileDevices={hasConnectedMobileDevices}
						csrf={config.csrf}
					/>
				)}
				{config.showCreateTerminalConfigPanel && <TerminalPanel/>}
				{(config.googleSyncUrl != null || config.microsoftSyncUrl != null) && (
					<CalendarSyncPanel googleSyncUrl={config.googleSyncUrl} microsoftSyncUrl={config.microsoftSyncUrl}/>
				)}
			</div>
			<div className="col-lg-6">
				<CalendarPanel calendarSubscriptionToken={config.calendarSubscriptionToken}/>
				<div className="panel panel-flat">
					<div className="panel-heading">
						<h5 className="panel-title">{messages["admin.clientSettings.absenceCalendar"]}</h5>
					</div>
					<div className="panel-body">
						<AbsenceCalendarLinks
							initialToken={config.absenceCalendarSubscriptionToken}
							showTeammemberAbsenceCalendar={config.showTeammemberAbsenceCalendar}
							showAllAbsenceCalendar={config.showAllAbsenceCalendar}
							timrBaseUrl={config.timrBaseUrl}
						/>
					</div>
				</div>
			</div>
		</div>
	);
}
